import { Identity, ResponseError } from '@ynap/api-utils';
import { timeout, delay } from '@ynap/promise-utils';
import { CREATE_FAST_USER_SUCCESS, CREATE_FAST_USER_REQUEST, CREATE_FAST_USER_ERROR } from '../constants/ActionTypes';

const createFastUserRequest = () => ({
    type: CREATE_FAST_USER_REQUEST,
});

const createFastUserSuccess = () => ({
    type: CREATE_FAST_USER_SUCCESS,
});

const createFastUserError = (error) => ({
    type: CREATE_FAST_USER_ERROR,
    error,
});

const createFastUser = (credentials) => (dispatch, getState, fetch) => {
    const { config, locale, uberToken } = getState();
    const { country } = locale;
    const clientRequest = config.clientRequest || config.head.clientRequest;
    const { baseUrl, clientId } = config.watsonService || config.global.services.commerce;
    const { brandId } = config.watsonService || config.global.application;
    const { excludePartnerizeAttribute = false } = config.head;
    const { firstName, gender, lastName, logonId, maMarketingConsent, maTrackingPartnerCode, personTitle } = credentials;

    const request = Identity.createFastUser(
        {
            baseUrl,
            country,
            brandId,
            clientId,
            logonId,
            uberToken,
            maMarketingConsent,
            ...(maTrackingPartnerCode && { maTrackingPartnerCode }),
            ...(gender && { gender }),
            ...(personTitle && { personTitle }),
            ...(firstName && { firstName }),
            ...(lastName && { lastName }),
        },
        excludePartnerizeAttribute,
    );

    dispatch(createFastUserRequest());

    return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
        .then((response) => {
            if (response.ok) {
                return dispatch(createFastUserSuccess());
            }

            throw new ResponseError(response);
        })
        .catch((error) => {
            dispatch(createFastUserError(error));
            throw error;
        });
};

export default createFastUser;